const selectAttribute = (stateSlice, attrName) => !!stateSlice && stateSlice[attrName];

// eslint-disable-next-line import/prefer-default-export
export { selectAttribute };
